import React from 'react';
import PropTypes from 'prop-types';

export function matches(q) {
  return window.matchMedia(q).matches;
}

export default class MediaQuery extends React.Component {
  state = {
    matches: matches(this.props.mediaQuery),
  };

  boundMediaEvent = this.handleMediaEvent.bind(this);

  componentDidMount() {
    this.mql = window.matchMedia(this.props.mediaQuery);
    this.mql.addListener(this.boundMediaEvent);
  }

  componentWillUnmount() {
    this.mql.removeListener(this.boundMediaEvent);
  }

  handleMediaEvent(mql) {
    const matches = mql.matches;
    this.setState({
      matches,
    });
    if (this.props.onMediaChange) {
      this.props.onMediaChange(matches);
    }
  }

  render() {
    if (this.props.render) {
      return this.props.render(this.state.matches);
    }
    return null;
  }
}

MediaQuery.propTypes = {
  mediaQuery: PropTypes.string.isRequired,
  render: PropTypes.func,
  onMediaChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/app/ui/core/common/MediaQuery.js